const useStyles = ({ theme }) => ({
  line: {
    position: "absolute",
    height: "80%", //typeElement == "Host" ? "150px" : "230px",
    minWidth: "3px",
    ml: "-5px",
  },

  textMedium: {
    color: theme.palette.color.textDisabled,
    fontSize: "0.85rem",
  },
  textLarge: { fontSize: "2em" },
  contentTab: { gap: "10px" },
  detailsCard: {
    backgroundColor: theme.palette.background.paperSelectedMaps,
    paddingX: "10px",
    paddingY: "15px",
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  text: {
    fontSize: "0.85em",
    width: "100%",
    whiteSpace: "normal",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 2, // Limite de 2 linhas
    WebkitBoxOrient: "vertical",
    textAlign: "left",
  },
  textAlerta: {
    fontSize: "0.85rem",

    color: theme.palette.color.textDisabled,
  },
  textHeaderAco: {
    fontSize: "0.85rem",

    color: theme.palette.color.text,
  },
});

export default useStyles;
